"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataStroginOptions = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var DeleteContentExplanation_1 = require("@features/SettingsPage/components/common/DeleteContentExplanation");
var clsx_1 = __importDefault(require("clsx"));
var dataStoringSlice_1 = require("@features/SettingsPage/state/dataStoringSlice");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("@components/Button"));
var PendingDeletion_1 = require("@features/SettingsPage/components/DataStoringSetting/PendingDeletion");
var _store_1 = require("@store");
function DataStroginOptions(_a) {
    var domain = _a.domain;
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, _store_1.useAppDispatch)();
    var periods = (0, react_redux_1.useSelector)(dataStoringSlice_1.periodsSelector);
    var registeredPeriod = (0, react_redux_1.useSelector)(dataStoringSlice_1.selectedPeriodSelector);
    var isDataStoringLoading = (0, react_redux_1.useSelector)(dataStoringSlice_1.isDataStoringLoadingSelector);
    var _b = __read((0, react_1.useState)(registeredPeriod), 2), selectedPeriod = _b[0], setSelectedPeriod = _b[1];
    (0, react_1.useEffect)(function () {
        dispatch((0, dataStoringSlice_1.fetchDataStoring)(domain));
    }, [domain]);
    (0, react_1.useEffect)(function () {
        if (registeredPeriod !== selectedPeriod) {
            setSelectedPeriod(registeredPeriod);
        }
    }, [registeredPeriod]);
    var saveDataStoring = function () {
        dispatch((0, dataStoringSlice_1.updateDataStoring)(domain, selectedPeriod));
    };
    var res = {
        willBeDeleted: [
            {
                text: t('settings:DATA_RETENTION_POLICY.WILL_BE_DELETED.TEXT'),
                icon: 'implioicons-image-1',
            },
        ],
        willNotBeDeleted: [
            {
                text: t('settings:DATA_RETENTION_POLICY.WILL_NOT_BE_DELETED.TEXT1'),
                icon: 'implioicons-statistics',
            },
            {
                text: t('settings:DATA_RETENTION_POLICY.WILL_NOT_BE_DELETED.TEXT2'),
                icon: 'implioicons-team',
            },
            {
                text: t('settings:DATA_RETENTION_POLICY.WILL_NOT_BE_DELETED.TEXT3'),
                icon: 'implioicons-network',
            },
        ],
    };
    return (react_1.default.createElement("div", { className: "col-xs-9 component" }, !isDataStoringLoading && (react_1.default.createElement("div", { className: "data-storing-options" },
        react_1.default.createElement("h2", null, t('settings:DATA_RETENTION_POLICY.TITLE')),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-8 left-side" },
                react_1.default.createElement("p", { className: "main-text" },
                    t('settings:DATA_RETENTION_POLICY.TEXT1'),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    t('settings:DATA_RETENTION_POLICY.TEXT2')),
                react_1.default.createElement("h4", null,
                    " ",
                    t('settings:DATA_RETENTION_POLICY.TEXT3')),
                react_1.default.createElement("div", { className: "periods-container" }, periods &&
                    periods.map(function (period, index) {
                        return (react_1.default.createElement("button", { type: "button", key: index, className: (0, clsx_1.default)({ 'storing-option-button': true, selected: period === selectedPeriod }), onClick: function () { return setSelectedPeriod(period); } }, "".concat(period, " ").concat(t('settings:DATA_RETENTION_POLICY.SELECT_PERIOD_BUTTON_TEXT_REACT', { count: period }))));
                    })),
                react_1.default.createElement("div", { className: "pending-deletion" },
                    react_1.default.createElement("h2", null, t('settings:DATA_RETENTION_POLICY.AWAITING_DELETION_TITLE')),
                    react_1.default.createElement(PendingDeletion_1.PendingDeletion, null)),
                !isDataStoringLoading && (react_1.default.createElement("div", { className: "gdpr__button-group" },
                    react_1.default.createElement(Button_1.default, { onClick: saveDataStoring, text: t('settings:DATA_RETENTION_POLICY.SAVE_BUTTON') })))),
            react_1.default.createElement("div", { className: "col-md-4 right-side" },
                react_1.default.createElement(DeleteContentExplanation_1.DeleteContentExplanation, { willBeDeleted: res.willBeDeleted, willNotBeDeleted: res.willNotBeDeleted })))))));
}
exports.DataStroginOptions = DataStroginOptions;
